import { showNotification } from "libs/utils";
import React from "react";
import { useTimer } from "react-timer-hook";

const KaitusAssessmentCounter = ({ expiryTimestamp } : any ) => {
  const {
    seconds,
    minutes,
    hours,
    days,
    isRunning,
    start,
    pause,
    resume,
    restart,
  } = useTimer({ expiryTimestamp, onExpire: () => {
    window.location.href = `/kaitus/complete`
  }});

  return (
    <div>
      남은시간 [{minutes}:{seconds}]
    </div>
  );
}
export default KaitusAssessmentCounter
